import { render } from "./Chat.vue?vue&type=template&id=00fffdee&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=00fffdee&scoped=true&lang=css"
import "./Chat.vue?vue&type=style&index=1&id=00fffdee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fffdee"]])

export default __exports__